import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";
import { useModalStore } from "@/hooks/useModalStore";
import { payPlaceTypeLists } from "@/components/config";
import DepositItems from "./DepositItems";
import HowFundsFlow from "./HowFundsFlow";
import LogoScroll from "./LogoScroll";
import "./CheckDeposit.scss";

// const items = [
//   {
//     src: `${s3ImageLink}ads-release-deposit-modal-refund.png`,
//     titleKey: "components.checkDepositModal.items.payForResultsTitle",
//     descKey: "components.checkDepositModal.items.payForResultsDesc",
//   },
//   {
//     src: `${s3ImageLink}ads-release-deposit-modal-contract.png`,
//     titleKey: "components.checkDepositModal.items.dualSidedContractTitle",
//     descKey: "components.checkDepositModal.items.dualSidedContractDesc",
//   },
//   {
//     src: `${s3ImageLink}ads-release-deposit-modal-organic.png`,
//     titleKey: "components.checkDepositModal.items.verifiedTrafficTitle",
//     descKey: "components.checkDepositModal.items.verifiedTrafficDesc",
//   },
// ];

export default function CheckDeposit() {
  const { t } = useTranslation();
  const {
    setShowChargeModal,
    setChargeModalInfo,
    setPayPlace,
    checkDepositModalInfo,
    setCheckDepositModalInfo,
    setShowPublishedVideoModal,
  } = useModalStore();
  return (
    <Modal
      title={
        <div className="text-2xl">
          {t("components.checkDepositModal.title", {
            defaultValue: "Deposit budget",
          })}
        </div>
      }
      open={checkDepositModalInfo?.visible}
      onCancel={() => {
        setCheckDepositModalInfo({
          visible: false,
          amount: null,
          isActiveCampaign: false,
        });
      }}
      footer={null}
      width={1072}
      styles={{
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        header: {
          padding: "32px 32px 0 32px",
        },
      }}
    >
      <div className="h-[75vh] flex flex-col">
        {/* 可滚动的内容区域 */}
        <div className="flex-1 overflow-y-auto px-8 py-8">
          <div className="self-stretch justify-center">
            <span className="text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-snug">
              {t("components.checkDepositModal.desc")}{" "}
            </span>
            <a
              href="https://screeching-vulture-3d3.notion.site/Top-Up-Campaign-Budget-Guide-25c298a7f2908016874fc36104573bbd"
              target="_blank"
              className="text-font&icon-link text-sm font-normal font-['DM_Sans'] leading-snug"
            >
              {t("components.checkDepositModal.guide")}
            </a>
          </div>
          <DepositItems />
          <HowFundsFlow />
          {/* Logo传送带 */}
          <LogoScroll />
        </div>

        {/* 底部固定的按钮区域 */}
        <div className="flex-shrink-0 px-8 pb-8 pt-4 bg-white">
          <div className="flex items-center justify-between">
            <div
              className="flex items-center gap-2 flex-1 cursor-pointer h-[40px] rounded-lg text-primary"
              onClick={() => {
                setShowPublishedVideoModal(true);
                setCheckDepositModalInfo({
                  visible: false,
                  amount: null,
                  isActiveCampaign: false,
                });
              }}
            >
              {t("components.checkDepositModal.actions.watchDemo")}
            </div>
            <div className="flex items-center gap-4">
              <Button
                className="flex-1 w-[213px]"
                size="large"
                onClick={() => {
                  setCheckDepositModalInfo({
                    visible: false,
                    amount: null,
                  });
                  window.open(
                    "https://calendly.com/meet-aha/aha-consultation-book-call?month=2025-10&date=2025-09-24",
                    "_blank",
                  );
                }}
              >
                {t("components.checkDepositModal.actions.contactSales")}
              </Button>
              <Button
                className="flex-1 w-[213px]"
                size="large"
                type="primary"
                onClick={() => {
                  setShowChargeModal(true);
                  setChargeModalInfo({
                    amount: checkDepositModalInfo?.amount,
                  });
                  setPayPlace(
                    checkDepositModalInfo?.isActiveCampaign
                      ? payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
                      : payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE,
                  );
                  setCheckDepositModalInfo({
                    visible: false,
                    amount: null,
                    isActiveCampaign: false,
                  });
                }}
              >
                {t("components.checkDepositModal.actions.depositNow")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
